import React from "react";
import { OurOffice } from "../office";
import { Carousel } from "../carousel";
import { About } from "../about";
import { CounterFacts } from "../counter-facts";
import { Services } from "../services";
import { Features } from "../features";
import { Countries } from "../countries";

function Home() {
  return (
    <>
      <Carousel />

      <About />

      <CounterFacts />

      <Services />

      <Features />

      <Countries />

      <div className="bg-light">
        <OurOffice />
      </div>
    </>
  );
}

export default Home;
